import { Injectable, inject } from '@angular/core';
import { ParagraphModel } from '@big-direkt/utils/shared';
import { DirectoryAnchorListItem } from '../models/directory-anchor-list-item.model';
import { ScrollService } from './scroll.service';

@Injectable({
    providedIn: 'root',
})
export class DirectoryService {
    private readonly scrollService = inject(ScrollService);

    private readonly nativeElements: { nativeElement: HTMLElement; id: string }[] = [];

    public addNativeElement(id: string, nativeElement: HTMLElement): void {
        this.nativeElements.push({ nativeElement, id });
    }

    public scrollToParagraph(id: string): void {
        const element = this.nativeElements.find(el => el.id === id);

        if (!element) {
            return;
        }

        this.scrollService.scroll(element.nativeElement);
    }

    public buildAnchorList(paragraphs: ParagraphModel[]): DirectoryAnchorListItem[] {
        const anchorList: DirectoryAnchorListItem[] = [];

        paragraphs.forEach((paragraph, index) => {
            if (!paragraph.directoryTitle) {
                return;
            }

            anchorList.push({
                content: paragraph.directoryTitle,
                index,
            });
        });

        return anchorList;
    }
}
